<template>
    <div class="social flex wrap center vcenter">
        <div class="flex center vcenter">
            <a href="https://www.instagram.com/atiyacrowd.fund?igsh=MTQ0bWloNTN3NzZ1Yw%3D%3D&utm_source=qr"
                target="_blank">
                <img v-lazy="'/images/socials/instagram.webp'" alt="آتیاکراد - اینستاگرام" loading="lazy" />
            </a>
        </div>
        <div class="flex center vcenter">
            <a href="https://t.me/atiyacrowd" target="_blank">
                <img v-lazy="'/images/socials/telegram.webp'" alt="آتیاکراد - تلگرام" loading="lazy" />
            </a>
        </div>
        <div class="flex center vcenter">
            <a href="https://Ble.ir/@atiyacrowd" target="_blank">
                <img v-lazy="'/images/socials/bale.webp'" alt="آتیاکراد - بله" loading="lazy" />
            </a>
        </div>
        <div class="flex center vcenter">
            <a href="https://eitaa.com/atiyacrowd" target="_blank">
                <img v-lazy="'/images/socials/eitaa.webp'" alt="آتیاکراد - ایتا" loading="lazy" />
            </a>
        </div>
        <div class="flex center vcenter">
            <a href="https://rubika.ir/atiyacrowd" target="_blank">
                <img v-lazy="'/images/socials/rubika.webp'" alt="آتیاکراد - روبیکا" loading="lazy" />
            </a>
        </div>
        <div class="flex center vcenter">
            <a href="https://www.aparat.com/atiyacrowd" target="_blank">
                <img v-lazy="'/images/socials/aparat.webp'" alt="آتیاکراد - آپارات" loading="lazy" />
            </a>
        </div>
        <div class="flex center vcenter">
            <a href="https://x.com/atiyacrowd" target="_blank">
                <img v-lazy="'/images/socials/x.webp'" alt="آتیاکراد - ایکس" loading="lazy" />
            </a>
        </div>
        <div class="flex center vcenter">
            <a href="https://www.linkedin.com/company/atiyacrowd/" target="_blank">
                <img v-lazy="'/images/socials/linkedin.webp'" alt="آتیاکراد - لینکدین" loading="lazy" />
            </a>
        </div>
        <div class="flex center vcenter">
            <a href="mailto:info@atiyehiraniancf.com" target="_blank">
                <img v-lazy="'/images/socials/mail.webp'" alt="آتیاکراد - ایمیل" loading="lazy" />
            </a>
        </div>
        <div class="flex center vcenter">
            <a href="https://www.youtube.com/@useatiyacrowd" target="_blank">
                <img v-lazy="'/images/socials/youtube.webp'" alt="آتیاکراد - یوتیوب" loading="lazy" />
            </a>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
export default {
    name: 'Social',
}
</script>

<style src="../assets/css/components/social.css"></style>